<template>
    <frontend-layout :hide-header="true" :hide-footer="true">
        <div class="flex h-screen flex-col lg:flex-row">
            <div class="h-full bg-white p-4 lg:w-1/2 lg:p-16">
                <div class="mx-auto h-full max-w-lg lg:ml-auto lg:mr-0">
                    <div class="mb-16">
                        <img
                            class="h-12"
                            src="/assets/art/logos/emtprep_logo_color@2x.png"
                        />
                    </div>
                    <div class="">
                        <div class="mb-4 text-[20px] font-bold">
                            Payment Information
                        </div>

                        <div
                            class="mb-12 flex flex-col gap-4 border-red-525 bg-red-125 p-4 font-semibold text-red-525"
                            v-if="
                                $page.props.existing_subscription &&
                                $page.props.existing_subscription.status ===
                                    'active'
                            "
                        >
                            <div class="">
                                Attention! You already have an active
                                subscription. Purchasing a new subscription will
                                not extend your current subscription.
                            </div>
                            <div class="">
                                <Link
                                    class="underline hover:cursor-pointer hover:text-red-400"
                                    :href="route('student.account.manage')"
                                >Manage my subscription
                                </Link>
                            </div>
                        </div>

                        <div class="">
                            <form
                                @submit.prevent="submitForm"
                                id="payment-form"
                            >
                                <div
                                    id="payment-element"
                                    class="bg-center bg-no-repeat"
                                >
                                    <!-- Elements will create form elements here -->
                                </div>

                                <div
                                    class="text-lg mt-4 rounded border-red-400 bg-red-400 p-4 font-semibold text-white"
                                    v-if="paymentError"
                                >
                                    {{ paymentError }}
                                </div>

                                <div
                                    v-if="showAdditionalBillingFields"
                                    class="mt-4"
                                >
                                    <div
                                        class="grid grid-cols-2 gap-4 opacity-50"
                                    >
                                        <div class="col-span-2">
                                            <form-input
                                                theme="dimmed"
                                                type="text"
                                                label="Billing Street"
                                                name="street"
                                                v-model="form.billingStreet"
                                            />
                                        </div>
                                        <div class="col-span-2">
                                            <form-input
                                                theme="dimmed"
                                                type="text"
                                                label="Billing City"
                                                name="city"
                                                v-model="form.billingCity"
                                            />
                                        </div>
                                        <div>
                                            <form-select
                                                theme="dimmed"
                                                label="Billing State"
                                                name="state"
                                                :allow-null="true"
                                                v-model="form.billingState"
                                                :options="stateOptions"
                                            />
                                        </div>
                                        <div>
                                            <form-input
                                                theme="dimmed"
                                                type="text"
                                                label="Billing Zip Code"
                                                name="postal_code"
                                                v-model="form.billingPostalCode"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    v-if="
                                        showAdditionalBillingFields &&
                                        (!form.billingStreet ||
                                            !form.billingCity ||
                                            !form.billingState ||
                                            !form.billingPostalCode)
                                    "
                                    class="mt-12 text-right"
                                >
                                    <span
                                        class="btn btn-primary opacity-50 hover:cursor-not-allowed"
                                    >
                                        Pay Now —— {{ $page.props.total }} USD
                                    </span>
                                </div>

                                <div
                                    v-else
                                    class="mt-8 flex items-center justify-start"
                                >
                                    <button
                                        v-if="!submittingPayment"
                                        class="btn btn-primary"
                                    >
                                        Pay Now ——
                                        {{ $page.props.total_usd }} USD
                                    </button>
                                    <span
                                        v-else
                                        class="btn btn-secondary opacity-50"
                                    >
                                        Please wait, processing payment
                                    </span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <!-- // cart-->
            <div class="h-full bg-gray-50 p-4 lg:w-1/2 lg:p-16">
                <div class="mx-auto lg:ml-0 lg:mr-auto lg:max-w-lg">
                    <div class="lg:mb-16 lg:h-12"></div>
                    <StudentCheckoutCart
                        :plan="plan"
                        :total="$page.props.total"
                        :subtotal="$page.props.subtotal"
                        :promo-code="order.payment_details?.promo_code"
                        :order-id="order.id"
                    />
                </div>
            </div>
        </div>

    </frontend-layout>
</template>

<script>
import FrontendLayout from "@/_Layouts/FrontendLayout";
import FormCheckbox from "@/Components/FormCheckbox";
import FormRadio from "@/Components/FormRadio";
import FormInput from "@/Components/FormInput";
import FormSelect from "@/Components/FormSelect";
import StudentCheckoutCart from "@/Components/StudentCheckoutCart";

const stripe = Stripe(window.stripeKey);

export default {
    name: "StudentRegisterPaymentForm",
    components: {
        StudentCheckoutCart,
        FormRadio,
        FormCheckbox,
        FrontendLayout,
        FormInput,
        FormSelect,
    },
    props: {
        user: {
            type: Object,
            default: {},
        },
        order: {
            type: Object,
            default: {},
        },
        subtotal: {
            type: String,
            default: "",
        },
        discount: {
            type: String,
            default: "",
        },
        total: {
            type: String,
            default: "",
        },
        plan: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            stripePublicKey: window.stripeKey,
            stripElements: null,
            paymentElement: null,
            paymentError: "",
            form: this.$inertia.form({
                billingEmail: this.user.email,
                billingFullName:
                    this.user.first_name + " " + this.user.last_name,
                billingStreet: null,
                billingCity: this.user.city,
                billingState: this.user.state,
                billingPostalCode: null,
            }),
            showAdditionalBillingFields: false,
            submittingPayment: false,
        };
    },
    methods: {
        updatePaymentFields(event) {
            this.showAdditionalBillingFields = event.value.type !== "card";
        },
        submitForm() {
            let vm = this;

            if (this.submittingPayment) {
                return;
            } else {
                this.submittingPayment = true;
            }

            this.confirmSetup().then(function (result) {
                if (result.error) {

                    vm.$honeybadger.notify(result.error)

                    if (
                        result.error.type === "card_error" ||
                        result.error.type === "validation_error"
                    ) {
                        vm.paymentError = result.error.message;
                    } else {
                        vm.paymentError =
                            "An unexpected error occurred. Please try again later.";
                    }
                }

                vm.submittingPayment = false;
            });
        },
        async confirmSetup() {
            let confirmParams = {
                payment_method_data: {
                    billing_details: {
                        name: this.user.first_name + " " + this.user.last_name,
                        email: this.user.email,
                        phone: null,
                        postal_code: null,
                        address: {
                            line1: this.form.billingStreet,
                            city: this.form.billingCity,
                            state: this.form.billingState,
                            postal_code: this.form.billingPostalCode,
                            country: "US",
                        },
                    },
                },
                return_url:
                    window.siteDomain +
                    "/finalize-subscription-order/" +
                    this.order.id,
            };

            if (this.showAdditionalBillingFields) {
                confirmParams.shipping = {
                    name: this.user.first_name + " " + this.user.last_name,
                    address: {
                        line1: this.form.billingStreet,
                        city: this.form.billingCity,
                        state: this.form.billingState,
                        postal_code: this.form.billingPostalCode,
                        country: "US",
                    },
                };
            }

            let elements = this.stripElements;

            let result = stripe.confirmSetup({
                elements,
                confirmParams: confirmParams,
            });

            return result;
        },
    },
    mounted() {
        let stripeOptions = {
            // hidePostalCode: true,
            clientSecret: this.order.payment_details.setup_intent_client_secret,
            appearance: {
                theme: "none",
                labels: "above",
                variables: {
                    colorPrimary: "#0D7AD9",
                    colorBackground: "#F2F0F0",
                    colorText: "#343434",
                    colorDanger: "#df1b41",
                    fontFamily: "Ideal Sans, system-ui, sans-serif",
                    spacingUnit: "2px",
                    borderRadius: "3px",
                    fontSizeBase: "18px",
                    spacingGridColumn: "16px",
                    spacingGridRow: "16px",
                },
                rules: {
                    ".Label": {
                        fontWeight: 600,
                    },
                    ".Label--resting": {
                        color: "#8C969C",
                    },
                    ".Label--floating": {
                        color: "#8C969C",
                        fontSize: "12px",
                    },
                    ".Input": {
                        color: "#121212",
                        padding: ".5rem",
                        paddingLeft: ".75rem",
                    },
                    ".Error": {
                        fontSize: "14px",
                    },
                },
            },
            // business: {name: "EMT-CE.com"},
            // fields: {
            //     billingDetails: {
            //         name: "auto",
            //         email: "auto",
            //         phone: "auto",
            //         address: {
            //             line1: "auto",
            //             line2: "auto",
            //             city: "auto",
            //             state: "auto",
            //             country: "auto",
            //             postalCode: "auto",
            //         },
            //     },
            // },
        };


        if (!this.user.ga_client_id) {

            let cookie = {};
            let gaClientId = null;

            document.cookie.split(';').forEach(function (el) {
                var splitCookie = el.split('=');
                var key = splitCookie[0].trim();
                var value = splitCookie[1];
                cookie[key] = value;
            });

            gaClientId = cookie["_ga"].substring(6);

            axios.post("/update-user-ga-client-id?cid=" + gaClientId);

        }

        this.stripElements = stripe.elements(stripeOptions);
        this.paymentElement = this.stripElements.create("payment");

        this.paymentElement.mount("#payment-element");

        this.paymentElement.on("change", this.updatePaymentFields);

    },
};
</script>

<style scoped></style>
